import { singletonHook } from "react-singleton-hook";
import { useEffect, useState } from "react";
import { getMaximusPrice, ZERO } from "../maximus/utils";
import useMaximus from "./useMaximus";
import useActiveWeb3React from "./connections/useActiveWeb3React";

const init = ZERO;

const useMaximusPriceImpl = () => {
  const [priceMAXI, setPriceMAXI] = useState(ZERO);

  const { active } = useActiveWeb3React();
  const maximus = useMaximus();

  useEffect(() => {
    const interval = setInterval(async () => {
      if (maximus && active) {
        getMaximusPrice(maximus).then((price) => {
          setPriceMAXI(price);
        });
      }
    }, 3000);

    if (maximus && active) {
      getMaximusPrice(maximus).then((price) => {
        setPriceMAXI(price);
      });
    }

    return () => clearInterval(interval);
  }, [maximus, active, setPriceMAXI]);

  return priceMAXI;
};

const useMaximusPrice = singletonHook(init, useMaximusPriceImpl);
export default useMaximusPrice;
